<script>
    export let id;
    export let value;
    export let current;
    export let placeholder = "Choisissez un fichier";
    export let reset = true;
    export let margin = true;
    export let type;
    export let height = auto;

    let fileinput;

    const onFileSelected = (e) => {
        console.log(e.target);
        let image = e.target.files[0];
        if (image) {
            let reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = (e) => {
                value = e.target.result;
            };
        } else {
            value = null;
        }
    };
</script>

<div class="form-group" class:in={current === id} class:filled={value} class:margin>
    <!-- icon -->
    <div class="icon-left">
        <i class="fas fa-upload" />
    </div>

    <span {id} class="avatar" on:click={() => fileinput.click()}>
        {#if value}
            {#if type == "image"}
                <img class="avatar" src={value} alt="jeu" {height} />
            {:else}
                {fileinput.files[0].name}
            {/if}
        {:else}
            {placeholder}
        {/if}
    </span>

    <input
        name={id}
        class="form-control"
        type="file"
        accept=".jpg, .jpeg, .png"
        on:focus={(e) => (current = id)}
        on:blur={() => (current = null)}
        on:change={(e) => onFileSelected(e)}
        bind:this={fileinput}
        {placeholder} />

    <!-- reset button -->
    {#if reset}
        <div class="icon-right reset">
            <button on:click={() => (value = null)} type="button" class="reset" tabindex="-1">
                <i class="fa fa-times-circle" />
            </button>
        </div>
    {/if}

    <!-- custom button -->
    <slot />
</div>

<style>
    span.avatar {
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 0.4em;
        padding-bottom: 0.4em;
    }

    .form-group {
        display: flex;
        position: relative;
        width: 100%;
        border-radius: 2px;
        background: #efefef;
        vertical-align: middle;
        color: #666;
        font-size: 14px;
        text-align: initial !important;
    }
    .margin.form-group {
        margin-bottom: 15px;
    }

    .in.form-group {
        -webkit-box-shadow: 0 2px 0 var(--primary-light-color);
        box-shadow: 0 2px 0 var(--primary-light-color);
    }
    .in.form-group .icon-left {
        color: var(--primary-color);
    }
    .form-group .icon-left {
        width: 34px;
        padding-top: 10px;
        font-size: 17px;
        font-weight: 400;
        line-height: 1;
        text-align: right;
        background-color: #eee;
        border: 0;
        color: var(--primary-light-color);
    }

    .form-group .icon-right {
        background: 0;
        cursor: pointer;
        padding: 10px 8px 0 5px;
    }

    .form-group:not(.filled) div.reset {
        visibility: hidden !important;
    }

    .form-group .form-control {
        position: relative;
        display: none;
        width: 100%;
        margin-bottom: 0;
        background: #efefef;
    }

    .form-group input {
        -webkit-appearance: none;
        border: 0;
        border-radius: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
        color: #666;
        font-size: 14px;
        height: 40px;
        padding-left: 10px;
        padding-right: 10px;
        resize: none;
        vertical-align: middle;
        width: 100%;
    }

    .form-group button {
        display: block;
    }

    .form-group button:not(:disabled):active {
        background-color: #efefef;
    }

    .form-group button.reset {
        cursor: pointer;
        background: none;
        color: #ccc;
        font-size: 18px;
        border: 0;
        border-radius: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
        margin: 0;
        padding: 0;
        text-align: left;
    }
</style>
